<template>
  <div class="nomination-review">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ContentHeader name="Review Nomination"></ContentHeader>
        <h4 class="text-black-50">You've received a nomination for <router-link to="">{{nominationCategory}}</router-link> by:</h4>
        <div class="pt-2 mb-3">
          <h6>
            <span class="text-black-50"><i class="fas fa-user fa-fw"></i> Name:</span>
            <router-link :to="'/thinktank-user/' + nomination._embedded.author[0].slug">{{nomination._embedded.author[0].name}}</router-link>
          </h6>
          <h6><span class="text-black-50"><i class="fas fa-globe fa-fw"></i> On:</span> {{ nominationDate }}</h6>
        </div>
        <h4 class="text-black-50" v-if="nomination.content.rendered !== ''">Nomination:</h4>
        <div class="mb-3" v-html="nomination.content.rendered"></div>
        <hr>
        <div v-if="!nominationAccepted">
          <div v-if="showSubstationFields">
            <div class="text-white mb-4 p-3 mb-2 bg-primary border border-primary font-weight-bold mt-1">Please note that upon acceptance of the nomination you understand that your race and gender will be published as part of the voting process.</div>
            <div class="row pt-2 mb-4" v-if="hideButton">
              <div class="col offset-md-4 offset-lg-4 offset-xl-3">
                <button type="button" class="btn btn-success btn-lg" v-on:click="updateNomination('Accepted')">
                  <i class="far fa-thumbs-up fa-fw"></i> Accept
                </button>
                <button type="button" class="btn btn-danger btn-lg" v-on:click="updateNomination('Declined')">
                  <i class="far fa-thumbs-down fa-fw"></i> Decline
                </button>
              </div>
            </div>
          </div>
          <div v-if="!showSubstationFields" role="alert" class="alert alert-success">{{acceptDeclineMsg}}</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ContentHeader from '@/components/ContentHeader'
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import WordpressRestURI from '@/helpers/WordpressRestURI.js'
import NominationNotification from '@/helpers/NominationNotification.js'
import PreContentHeader from '@/components/PreContentHeader'
import { mapGetters } from 'vuex'
export default {
  components: {
    PreContentHeader,
    ContentHeader
  },
  computed: {
    ...mapGetters([
      'getProfileDetails'
    ])
  },
  data () {
    return {
      contentReady: false,
      contentLoadError: '',
      nomination: {},
      nominationCategory: '',
      showSubstationFields: true,
      hideButton: true,
      acceptDeclineMsg: '',
      nominationAccepted: false,
      nominationDate: ''
    }
  },
  created () {
    document.title = this.$route.name + ' - ThinkTank'
    var self = this
    WordpressRestAPI.getViewContent('employment_equity/' + self.$route.params.id + '?_embed')
      .then(response => {
        self.nomination = response.data
        self.getDate()
        self.nominationCategory = response.data._embedded['wp:term'][1].map(x => x.name).filter(x => x !== 'VE Awards').join()
        self.contentReady = true
        self.nominationAccepted = response.data.equity_accept_reject[0] !== 'Pending'
      })
      .catch(e => {
        self.childContentLoadError = 'Oops! We had a problem with loading your nomination. Please try again later.'
        console.error(e)
      })

  },
  methods: {
    getDate: function() {
      let d = this.nomination.date.split('T')
      let options = {year: "numeric", month: "short", day: "numeric"};
      this.nominationDate = new Intl.DateTimeFormat('en-US', options).format(new Date(d[0]))
    },
    updateNomination: function (status) {
      var self = this
      if ((self.getProfileDetails.email.toLowerCase() === self.nomination.equity_nominee_email[0].toLowerCase()) || (self.getProfileDetails.username.toLowerCase() === self.nomination.equity_nominee_email[0].toLowerCase())) {
        self.hideButton = false
        var updateFinalTeamNomination = false
        var updateNominationStatus = false
        var sendNomination = {
          method: 'POST',
          data: {
          equity_accept_reject: status
        },
          headers: {
            'Authorization': localStorage.getItem('userToken'),
            'Content-Type': 'application/json'
          },
          json: true
        }

        WordpressRestAPI.endpointWithAuthetication(sendNomination, 'employment_equity/' + self.$route.params.id)
          .then(function (response) {
            self.showSubstationFields = false
            self.acceptDeclineMsg = 'You have ' + status + ' your nomination from ' + self.nomination._embedded.author[0].name
          })
          .catch(function (e) {
            console.error(e)
          })
      }
    }
  },
  watch: {
    getProfileDetails (newDetails, oldDetails) {
      if (this.getProfileDetails.email !== this.nomination.equity_nominee_name[0]) {
        this.$router.push('/')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/EMEquityReview.vue